/*
 * SagoMax — "Max", the on-site virtual assistant (zero-cost, dependency-free).
 *
 * Max answers a wide range of questions on-device from a rule-based knowledge base
 * with accent-stripping + Levenshtein fuzzy matching (tolerant of typos and shaky
 * Italian). It feels like an AI chatbot but uses NO tokens/API. The WhatsApp option
 * stays hidden until it's actually useful — a fallback (unrecognised question) or a
 * gentle human-operator request. Optional middleware relay: services/whatsapp-bot.
 * Keep the KB in sync with services/whatsapp-bot/src/kb.js.
 */
(function () {
  'use strict';

  var root = document.getElementById('sx-wa');
  if (!root) return;

  var PHONE = (root.dataset.phone || '').replace(/\D/g, '');
  var PREFILL = root.dataset.prefill || 'Ciao SagoMax!';
  var BACKEND = (root.dataset.backend || '').trim().replace(/\/$/, '');
  var AVATAR = root.dataset.avatar || '';
  if (!PHONE) return;

  var panel = document.getElementById('sx-wa-panel');
  var fab = document.getElementById('sx-wa-fab');
  var body = document.getElementById('sx-wa-body');
  var quick = document.getElementById('sx-wa-quick');
  var form = document.getElementById('sx-wa-form');
  var input = document.getElementById('sx-wa-input');
  var cta = document.getElementById('sx-wa-cta');
  var closeBtn = root.querySelector('.sx-wa__close');

  /* ================= Max — knowledge base ================= */
  // Factual answers in Max's warm voice. NEVER invent prices, lead times or
  // shipping costs — those live on the product pages.
  var A = {
    ordine: "Funziona così, facile facile 😊\n1. Mi dici prodotto, misure, colori e grafica\n2. Fai l'ordine e il pagamento\n3. Prepariamo gratis la bozza e te la mandiamo per l'ok\n4. Dopo la tua conferma produciamo tutto nel nostro laboratorio a Roma\n5. Ricevi a casa il tuo allestimento, pronto da montare, spedito con GLS e imballato con cura\nDimmi cosa vorresti realizzare e ti guido io ✨",
    prodotti: "Realizziamo tantissime cose, tutte su misura e personalizzate 🎨 Tra le più richieste:\n• Sagome personalizzate\n• Pannelli scenografici, archi, vele e fondali\n• Photo booth e corner bomboniere\n• Set di cilindri\n• Banner e striscioni in PVC, poster\nPuoi scegliere dimensioni, grafica, colore e stampa. Dimmi cosa hai in mente e troviamo insieme la soluzione perfetta 😊",
    preventivo: "Il bello e\u2019 che non serve aspettare un preventivo: i prezzi sono tutti online, IVA inclusa, e io li conosco a memoria.\nDimmi cosa ti serve \u2014 \u00abarco 120\u00d7200\u00bb, \u00abfondale per battesimo\u00bb, \u00absagoma del logo\u00bb \u2014 e ti do subito prezzo, misure e link. La grafica, se non ce l\u2019hai, la prepariamo noi: e\u2019 sempre compresa.",
    prezzi: "Prezzi tutti online e IVA inclusa, senza sorprese \u2014 e senza dover chiedere niente a nessuno.\nDimmi il pezzo che ti interessa e te lo dico all\u2019istante, misura per misura. La spedizione la paghi al costo, senza ricarichi: te la calcola il carrello prima del checkout.",
    sagome: "Le sagome sono tra le cose che amiamo di più! 😍 Sono tutte autoportanti: fino a 50 cm arrivano con una pinnetta posteriore, dai 60 cm in su con i piedi a mezzaluna (in opzione anche un supporto posteriore). Il prezzo dipende dall'altezza, dalla larghezza del soggetto e dalla finitura: lo trovi nella scheda del prodotto. Mandami un'immagine di ciò che vuoi e ti aiuto a scegliere la misura giusta 😊",
    grafica: "La grafica è inclusa e la creiamo noi insieme a te, senza costi aggiuntivi 💕 Puoi mandarci una tua foto, un logo o un'immagine: prima dell'ordine controlliamo che la qualità basti per una bella stampa e, se serve, cerchiamo un'alternativa migliore. L'elaborazione del file è compresa ✨",
    bozze: "Le bozze le prepariamo noi ✏️ Sono incluse fino a 3 revisioni e le realizziamo dopo la conferma e il pagamento dell'ordine. Te le mandiamo prima della stampa: controlli con calma nomi, testi, date, misure e forma, e solo quando è tutto perfetto e ci dai l'ok, stampiamo 😊",
    materiali: "Usiamo soprattutto il PVC: leggero, resistente e ben stabile 🎨 Per le sagome scegliamo lo spessore in base alla misura (Forex 5 mm fino a 50 cm, PVC Piuma 1 cm fino a 150 cm, 2 cm oltre); le strutture le facciamo in PVC Piuma da 2 cm. Non usiamo legno né polistirolo. Se hai un'idea in mente mandaci una foto e vediamo come realizzarla 😊",
    strutture: "Archi, vele e fondali sono il nostro pane.\nTi servono tre scelte: la misura (dai 100\u00d7180 ai 200\u00d7200), se la vuoi bianca da vestire tu oppure gia\u2019 stampata con la tua grafica, e se la preferisci intera o richiudibile \u2014 quest\u2019ultima entra in auto e ha il piede di sostegno gia\u2019 incluso.\nDimmi forma e misura e ti do prezzo e link al volo.",
    poster: "Certo! Se hai già la struttura possiamo farti solo il poster, cioè il rivestimento grafico 😊 Se è una struttura SagoMax lo facciamo su misura perfetta; se è di un altro produttore mandami una foto e ti dico subito la soluzione migliore (per vele e cupole di solito conviene un poster rettangolare da adattare in fase di applicazione) 💕",
    spedizioni: "Spediamo ogni giorno in tutta Italia con GLS, assicurata e imballata come si deve \uD83D\uDCE6\nLa spedizione la paghi al costo, quello che il corriere fa pagare a noi, senza ricarichi: la cifra esatta la vedi gi\u00e0 nel carrello, e al checkout \u00e8 la stessa. Se sei a Roma puoi anche ritirare in sede senza pagare la spedizione.\nOrdina almeno 10 giorni lavorativi prima dell\u2019evento e vai sul sicuro \u2014 se hai una data stretta dimmela, controllo io se ci stiamo.",
    ritiro: "Certo, e non paghi la spedizione 😊 Scegli «ritiro in sede» al checkout e il costo sparisce dal totale.\nSiamo a Roma, in Via Acuto 147, dal lunedì al venerdì 8.00–13.00 e 14.00–17.00.\nVisto che produciamo tutto su misura dopo l\u2019ordine, non è pronto subito: ti avvisiamo noi appena puoi venire a prenderlo — aspetta il nostro ok prima di metterti in viaggio 💕",
    tempi: "I tempi dipendono dal prodotto e li trovi nella scheda di ogni articolo ⏱️ La bozza la prepariamo appena parte l'ordine e te la mandiamo per l'ok; poi partiamo con la produzione. Ti consiglio di ordinare almeno 10 giorni lavorativi prima dell'evento (sabato e domenica non contano). Dimmi la data della festa e controllo subito se facciamo in tempo 😊",
    pagamenti: "Puoi pagare in tutta sicurezza come preferisci 🔒 Accettiamo:\n• Carte di credito e debito (Visa, Mastercard, Amex, Maestro)\n• Apple Pay, Google Pay e Shop Pay\n• Klarna (in 3 rate, previa approvazione)\nNon accettiamo PayPal, bonifico o contrassegno. Se hai un dubbio su un metodo, chiedimi pure 😊",
    telefono: "Se e\u2019 una domanda sul prodotto sono piu\u2019 veloce io: prezzi, misure, tempi e disponibilita\u2019 li ho tutti qui, e rispondo adesso.\nSe pero\u2019 preferisci una persona, nessun problema: tocca «Parla con una persona» qui sotto e ti passo il team su WhatsApp.",
    dove: "Siamo a Roma, in Via Acuto 147, dove abbiamo il nostro laboratorio 🇮🇹 Produciamo tutto internamente e spediamo ogni giorno in tutta Italia.\nSe preferisci puoi ritirare qui senza pagare la spedizione: siamo aperti dal lunedì al venerdì, 8.00–13.00 e 14.00–17.00. Ti avvisiamo noi appena il tuo ordine è pronto 😊",
    contatti: "Sono io il posto giusto per iniziare: conosco tutto il catalogo, i prezzi e i tempi, e non ti faccio aspettare.\nPer le cose formali c\u2019e\u2019 info@sagomax.it. Ma chiedimi pure qui: nove volte su dieci si risolve in due messaggi.",
    garanzia: "Nessun pensiero, ci pensiamo noi 💕 Con la Garanzia SagoMax 100%, se il pacco arriva danneggiato o in ritardo per un errore nostro troviamo la soluzione: rifacciamo, sostituiamo o rimborsiamo. La tua serenità viene prima di tutto.",
    recesso: "Ci tengo a spiegartelo con chiarezza 💕 I nostri prodotti sono fatti su misura e personalizzati apposta per te, quindi — come previsto dall'art. 59 del Codice del Consumo — non rientrano nel diritto di recesso ordinario dei 14 giorni. Ma non resti mai scoperto: valgono sempre la garanzia legale di conformità di 2 anni e la nostra Garanzia SagoMax 100%, perciò se qualcosa arriva danneggiato, difettoso o non conforme lo rifacciamo, sostituiamo o rimborsiamo noi. Trovi tutto nella pagina Spedizioni e resi; se hai un caso particolare raccontamelo pure e, se preferisci, ti passo una persona del team 😊",
    misure: "Lavoriamo tutto su misura 📐 Si va da 20, 30 o 50 cm fino a un massimo di 300 × 200 cm per pannelli e strutture. Non ho misure standard da darti: dipende dallo spazio, dall'effetto che vuoi e dal trasporto — dimmi lo spazio che hai e ti consiglio io la misura giusta 😊 (per le sagome da 20 e 30 cm c'è un piccolo ordine minimo). Per i photo booth partiamo dall'altezza del foro per il viso.",
    eventi: "Che bello! 🎉 Realizziamo allestimenti per tantissime occasioni: matrimonio, battesimo, comunione, compleanno, baby shower, gender reveal, lauree, feste a tema ed eventi aziendali. Dimmi che evento stai organizzando e ti indirizzo alle idee giuste ✨",
    campioni: "Nelle schede trovi foto di allestimenti veri, non render.\nDimmi tema e colori e ti porto dritto ai prodotti giusti \u2014 oppure parti dai set, che sono gia\u2019 abbinati e fanno scena da soli.",
    sconti: "Il risparmio vero sono i set: gli stessi pezzi del catalogo, gia\u2019 abbinati, e costano meno che comprarli singolarmente.\nDimmi che evento stai organizzando e ti dico quale set ti conviene davvero.",
    urgenza: "Dimmi la data dell\u2019evento e cosa ti serve: controllo subito se ci arriviamo \u23F3\nSe i tempi sono stretti c\u2019e\u2019 la Produzione Prioritaria, che attivi da solo nel carrello. E se una misura e\u2019 troppo lunga da produrre, ti propongo l\u2019alternativa che arriva in tempo.",
  };

  // Quick-reply chips shown up front (a friendly subset of the topics).
  // «Parla con una persona» sta in fondo di proposito: e' l'uscita di sicurezza,
  // non la prima cosa da proporre — ma dev'essere sempre in vista, senza doverla
  // digitare e senza doverla meritare.
  var TOPICS = [
    { id: 'prodotti', chip: 'Cosa realizzate', q: 'Cosa realizzate?' },
    { chip: 'I set completi', run: function () { addMsg('Fammi vedere i set completi', 'user'); setsAnswer(); } },
    { id: 'sagome', chip: 'Le sagome', q: 'Come funzionano le sagome?' },
    { id: 'ordine', chip: 'Come funziona', q: 'Come funziona?' },
    { id: 'tempi', chip: 'Tempi e consegna', q: 'In quanto arriva?' },
    { chip: 'Parla con una persona', run: function () {
        addMsg('Vorrei parlare con una persona', 'user');
        humanHandoff('Ciao SagoMax, vorrei parlare con una persona del team.');
      } }
  ];

  // Keyword routing, priority order. Stems are accent-free (see normalize()).
  // __human__ and __reclamo__ are handled specially (they reveal WhatsApp).
  var ROUTES = [
    { id: "__human__", kws: ["operator", "operatrice", "assistente vero", "assistente uman", "centralino", "parlare con una persona", "parlare con qualcuno", "un responsabile", "il titolare", "persona reale", "persona vera", "con qualcuno", "essere umano", "un vostro addett", "una vostra collega", "coi vostri"] },
    { id: "__reclamo__", kws: ["reclamo", "lamentel", "arrabbiat", "furios", "delus", "pessim", "truffa", "vergogn", "insoddisfatt", "schifo", "scandal", "seconda volta", "sempre errori", "assurdo"] },
    { id: "recesso", kws: ["recess", "ripensament", "ho ripensat", "ci ho ripensat", "cambiato idea", "cambiare idea", "cambio idea", "ho cambiato idea", "annullare l ordin", "annullare lordin", "annullare un ordin", "disdire l ordin", "disdire lordin", "cancellare l ordin", "cancellare lordin", "restitu", "un reso", "il reso", "fare un reso", "reso gratuit", "reso del prodott", "rendere il prodott", "voglio rendere", "non mi piace", "non mi piac", "indietro il prodott", "diritto di recess"] },
    { id: "garanzia", kws: ["garanz", "rimbors", "danneggiat", "rotto", "rovinat", "difett", "sostituz", "arrivato rotto", "arrivata rotta", "pacco danneggiat", "e arrivato rovinat"] },
    { id: "urgenza", kws: ["urgent", "urgenza", "fretta", "domani", "dopodomani", "ultimo minuto", "poco tempo", "pochissimo tempo", "di corsa", "accelerar", "fare prima", "entro sabato", "entro domenica", "entro venerdi", "entro luned", "entro marted", "entro mercoled", "entro gioved", "per sabato", "per domenica", "servirebbe entro", "mi serve entro"] },
    { id: "bozze", kws: ["bozz", "anteprima", "prima di stampar", "vedere prima di stampar", "revision", "quante prove", "prova grafic", "approvazione grafic", "vedere una prova"] },
    { id: "pagamenti", kws: ["pagament", "paga", "pagh", "paypal", "bonific", "contrasseg", "alla consegna", "klarna", "satispay", "apple pay", "samsung pay", "a rate", "rateizz", "carta di credito", "carta credito", "come si paga", "come pago", "metodi di pagam"] },
    { id: "spedizioni", kws: ["spedi", "corriere", "gls", "consegna a casa", "arriva a casa", "a domicilio", "tracking", "imball", "pacco", "pacchi", "spese di spedizion", "costo spedizion", "costo della spedizion", "quanto costa la spedizion", "spedite in tutta italia", "spedite anche"] },
    { id: "tempi", kws: ["tempi", "quanto tempo", "tempo di", "giorni", "per quando", "quanto ci met", "quanto prima", "quando arriv", "quando ricev", "quando lo ricevo", "quando e pronto", "quando sara pronto", "pronto", "in tempo", "consegn"] },
    { id: "poster", kws: ["solo il poster", "solo poster", "solo il rivestiment", "solo rivestiment", "solo la stampa", "acquistare solo", "comprare solo", "stampare solo", "farmi solo", "gia la struttura", "ho la struttura", "gia una struttura", "struttura che ho gia", "ho gia larco", "ho gia la vela"] },
    { id: "sagome", kws: ["sagom", "autoportant", "sta in piedi", "stanno in piedi", "piedi a mezzaluna", "pinnetta"] },
    { id: "strutture", kws: ["arco", "archi", "vela", "vele", "fondal", "richiudibil", "concentric", "smerlat"] },
    { id: "materiali", kws: ["material", "di cosa e fatto", "di cosa sono fatt", "plastica", "qualit", "resist", "si piega", "se piega", "cartone", "forex", "pvc", "legno", "polistir", "polistirol", "finitur", "spessore", "che stampa"] },
    { id: "misure", kws: ["misur", "dimension", "quanto e grande", "quanto grande", "altezza", "larghezza", "grandezza", "quanto misura", "misura massim", "dimensione massim", "misura minim", "ordine minimo", "fino a che", "alta", "alte", "alto", "metri", "un metro", "due metri", "300", "200"] },
    { id: "preventivo", kws: ["preventiv", "richiedere un prevent", "fare un prevent", "avere un prevent", "vorrei un prevent", "quotazion", "come richiedo", "come si richiede", "come faccio a chiedere", "mi fate un prevent"] },
    { id: "prezzi", kws: ["prezz", "costo", "costa", "costano", "costi", "coster", "quanto vien", "quanto ven", "quanto mi cost", "budget", "listino", "tariff"] },
    { id: "prodotti", kws: ["che prodotti", "quali prodotti", "cosa realizzat", "che cosa realizzat", "cosa producete", "cosa create", "cosa fate", "che cosa fate", "cosa vendete", "cosa posso ordinar", "cosa posso comprar", "comprare da voi", "i vostri prodott", "tipi di prodott", "fate anche", "scenografic", "pannell", "corner bombonier", "photo booth", "photobooth", "striscion", "banner", "cilindri"] },
    { id: "grafica", kws: ["grafic", "graffic", "grafik", "personaliz", "pesonaliz", "personalizz", "logo", "scritt", "font", "disegn", "i nomi", "colore", "colori", "mia immagine", "mia foto", "mio logo", "una foto mia", "usare una immagine", "usare una foto", "risoluzion", "immagine mia"] },
    { id: "ritiro", kws: ["ritir", "venire a prend", "passare a prend", "ritirare in sede", "ritiro in sede", "ritiro di persona", "vengo a prender", "posso ritirar"] },
    { id: "dove", kws: ["dove siete", "dove vi trov", "dove si trov", "dove site", "vostra sede", "laboratorio", "negozio", "showroom", "siete a roma", "a roma", "via acuto", "indirizzo", "in che zona", "zona di roma", "dove producete"] },
    { id: "telefono", kws: ["telefonic", "al telefono", "per telefono", "numero di telefono", "vostro numero", "chiamar", "chiamarvi", "sentirci", "parlare al telefono", "una telefonat", "vi chiamo", "posso chiamar"] },
    { id: "contatti", kws: ["contatt", "email", "e mail", "vostra mail", "come vi contatt", "come vi raggiungo", "come vi scrivo", "orari", "aperti", "aperto", "quando siete"] },
    { id: "campioni", kws: ["campion", "esempi", "portfolio", "vostri lavori", "come vien", "come sono fatt", "galleria", "foto dei lavor", "realizzazion", "vedere foto", "delle foto", "qualche foto", "qualche lavoro", "vedere qualche", "mi fate vedere", "far vedere", "fotografie", "vedere dei lavor", "vedere delle foto"] },
    { id: "eventi", kws: ["matrimoni", "battesim", "battes", "comunion", "cresim", "complean", "baby shower", "babyshower", "gender reveal", "laure", "18 anni", "18esimo", "diciotto", "diciottesimo", "nascita", "anniversari", "festa a tema", "prima comunione", "aziendal", "evento aziend", "nubilato", "celibato", "addio al"] },
    { id: "sconti", kws: ["sconto", "sconti", "offert", "promo", "codice sconto", "coupon", "saldi"] },
    { id: "ordine", kws: ["ordin", "acquist", "comprar", "come si fa", "procedere", "carrello", "checkout", "come faccio a", "come funziona il", "come funziona", "come si ordina", "come acquisto"] },
  ];
  var POSTER_KWS = ROUTES.filter(function (r) { return r.id === 'poster'; })[0].kws;

  // Fuzzy dictionary: canonical word -> intent id. Levenshtein-tolerant so common
  // misspellings (spedizzione, personalizato, garanzzia, matrimnio…) still route.
  // Keys must be >= 4 chars (fuzzyIntent ignores shorter tokens).
  var FUZZY = {
    spedizione: "spedizioni", corriere: "spedizioni", consegna: "tempi", prezzo: "prezzi",
    preventivo: "preventivo", quotazione: "preventivo", garanzia: "garanzia", rimborso: "garanzia",
    recesso: "recesso", ripensamento: "recesso", restituire: "recesso", restituzione: "recesso",
    personalizzare: "grafica", grafica: "grafica", bozza: "bozze", bozze: "bozze",
    materiale: "materiali", plastica: "materiali", forex: "materiali", polistirolo: "materiali",
    legno: "materiali", pagamento: "pagamenti", klarna: "pagamenti", bonifico: "pagamenti",
    satispay: "pagamenti", matrimonio: "eventi", battesimo: "eventi", compleanno: "eventi",
    comunione: "eventi", laurea: "eventi", sagoma: "sagome", sagome: "sagome",
    pannello: "prodotti", arco: "strutture", fondale: "strutture", poster: "poster",
    ritiro: "ritiro", telefono: "telefono", misure: "misure", dimensioni: "misure",
    catalogo: "ordine", ordine: "ordine", prodotti: "prodotti", operatore: "__human__",
    campioni: "campioni", sconto: "sconti", urgente: "urgenza", contatti: "contatti",
  };

  // Social small-talk (never reveals WhatsApp). Warm, varied replies.
  var SOCIAL = {
    botq: {
      kws: ["chi sei", "come ti chiami", "sei un robot", "un robot", "robot o", "sei umano", "sei un umano", "sei un uman", "sei una persona", "sei reale", "sei un bot", "ti chiami", "sei vera", "sei un uomo", "sei una macchina"],
      replies: ["Sono Max, l'assistente virtuale di SagoMax 😊 Ti aiuto a scegliere e personalizzare il tuo allestimento. E se ti serve una persona in carne e ossa, la chiamo io per te 💕"]
    },
    greeting: {
      kws: ['ciao', 'salve', 'buongiorno', 'buonasera', 'buon pomeriggio', 'buondi', 'hey', 'ehi', 'ehila', 'hola'],
      replies: [
        "Ciao, sono Max! 🎈 L'assistente di SagoMax. Raccontami: che festa stai organizzando? Posso aiutarti con idee, personalizzazione, tempi e tanto altro 💕",
        "Ciao ciao! 😊 Sono Max di SagoMax. Dimmi pure, per quale occasione stai cercando un allestimento? ✨",
        "Ehilà, sono Max! 🎈 Sono qui per aiutarti a rendere speciale la tua festa. Cosa ti serve? 💕"
      ]
    },
    thanks: {
      kws: ['grazie', 'grazi', 'gentilissim', 'sei un tesoro', 'ottimo grazie', 'perfetto grazie', 'grazie mille'],
      replies: ["Di niente, è un piacere! 💕", "Figurati! 😊 Sono qui per questo.", "Ma grazie a te! 🎈 Se ti serve altro, chiedi pure."]
    },
    bye: {
      kws: ['arrivederci', 'a presto', 'ciao ciao', 'buona giornata', 'a dopo', 'ci sentiamo', 'buona serata'],
      replies: ["A presto! Che sia una festa bellissima 🎉 Mi trovi sempre qui 💕", "Ciao ciao! Un abbraccio e buona festa 🎈", "A prestissimo! 😊 Se ti serve, io sono qui."]
    },
    affirm: {
      kws: ['va bene', 'perfett', 'benissimo', 'daccordo', 'd accordo', 'ottimo', 'esatto', 'senza problemi'],
      replies: ["Perfetto! 😊 Dimmi pure come posso aiutarti.", "Benissimo! 🎈 Cosa ti serve?", "Ottimo! Sono qui per qualsiasi cosa 💕"]
    }
  };

  // Tiny one-word messages, resolved before keyword routing.
  var EXACT = { ok: 'affirm', okay: 'affirm', 'va bene': 'affirm', si: 'affirm', perfetto: 'affirm', capito: 'affirm', 'ho capito': 'affirm', grazie: 'thanks', 'grazie mille': 'thanks', ciao: 'greeting', salve: 'greeting' };

  /* ==================== MAX 2.0 — il catalogo vivo =========================
     Max non recita un copione: legge il catalogo vero (/collections/all?view=max-json),
     con i prezzi che sono online in questo momento. Se domani cambia un prezzo in
     Shopify, cambia la risposta — non esiste una lista parallela che possa mentire.
     Si scarica alla PRIMA apertura del pannello (mai a caricamento pagina: zero peso
     per chi non lo apre) e resta in sessionStorage per il resto della visita. */
  var CAT = null;
  var catPromise = null;
  var CAT_KEY = 'sxmax_cat_v2';

  function loadCatalog() {
    if (CAT) return Promise.resolve(CAT);
    if (catPromise) return catPromise;
    try {
      var cached = sessionStorage.getItem(CAT_KEY);
      if (cached) { CAT = JSON.parse(cached); return Promise.resolve(CAT); }
    } catch (e) {}
    // Niente header Accept: con «application/json» Shopify ignora ?view= e
    // risponde 404/406 (o il JSON nativo della collezione), mai max-json.
    catPromise = fetch('/collections/all?view=max-json', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.p || !data.p.length) return null;
        CAT = data;
        try { sessionStorage.setItem(CAT_KEY, JSON.stringify(data)); } catch (e) {}
        return CAT;
      })
      .catch(function () { return null; });
    return catPromise;
  }

  function euro(cents) {
    if (typeof cents !== 'number') return '';
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* Prezzo corto di un prodotto del catalogo. Al m² (mq) `pr` è già la tariffa:
     si dice «da … al m²», perché il totale dipende dalla misura (vedi max-json). */
  function prezzoCorto(pr) {
    if (pr.mq) return 'da ' + euro(pr.pr) + ' al m²';
    return (pr.vr && pr.vr.length > 1 ? 'da ' : '') + euro(pr.pr);
  }

  /* Sinonimi: come parla un cliente vs come si chiama a catalogo. Senza questo
     «sfondo per foto» non troverebbe mai un fondale. */
  var SYN = {
    sfondo: 'fondale', sfondi: 'fondale', backdrop: 'fondale', pannello: 'fondale', pannelli: 'fondale',
    telo: 'telone', teli: 'telone', striscione: 'telone', striscioni: 'telone', banner: 'telone',
    stampa: 'stampato', stampata: 'stampato', stampati: 'stampato', colorato: 'stampato', grafica: 'stampato',
    bianca: 'bianco', bianchi: 'bianco', neutro: 'bianco', 'da personalizzare': 'bianco',
    colonna: 'cilindro', colonne: 'cilindro', piedistallo: 'cilindro', 'porta torta': 'cilindro',
    tappetino: 'tappeto', pedana: 'tappeto', moquette: 'tappeto',
    scritta: 'scritta', lettere: 'scritta', nome: 'scritta', lettering: 'scritta',
    adesivo: 'adesivi', stickers: 'adesivi', bollini: 'adesivi',
    kit: 'set', pacchetto: 'set', completo: 'set', bundle: 'set',
    ruota: 'ruota', 'gioco': 'ruota',
    tondo: 'tondo', rotondo: 'tondo', circolare: 'tondo',
    richiudibile: 'richiudibile', pieghevole: 'richiudibile', smontabile: 'richiudibile',
    // Plurali: l'italiano non si stemma con una regola sola (arco\u2192archi cambia la
    // radice), e un cliente scrive «avete archi?» molto piu' spesso di «avete arco?».
    archi: 'arco', vele: 'vela', fondali: 'fondale', sagome: 'sagoma', cilindri: 'cilindro',
    tappeti: 'tappeto', scritte: 'scritta', teloni: 'telone', tavoli: 'desk', cornici: 'cornice',
    matrimoni: 'matrimonio', battesimi: 'battesimo', compleanni: 'compleanno', lauree: 'laurea',
    comunioni: 'comunione', cresime: 'cresima', anniversari: 'anniversario'
  };

  var STOP = {
    il: 1, lo: 1, la: 1, i: 1, gli: 1, le: 1, un: 1, uno: 1, una: 1, di: 1, del: 1, della: 1, dei: 1,
    per: 1, con: 1, che: 1, cosa: 1, come: 1, quanto: 1, quanti: 1, quale: 1, quali: 1, mi: 1, ci: 1,
    e: 1, ed: 1, a: 1, da: 1, in: 1, su: 1, al: 1, alla: 1, ai: 1, sul: 1, sulla: 1, se: 1, non: 1,
    vorrei: 1, voglio: 1, avete: 1, fate: 1, serve: 1, servono: 1, ho: 1, sono: 1, essere: 1, fare: 1,
    prezzo: 1, prezzi: 1, costa: 1, costano: 1, costo: 1, euro: 1, misura: 1, misure: 1, cm: 1, mio: 1, mia: 1
  };

  function tokens(text) {
    var n = normalize(text);
    Object.keys(SYN).forEach(function (k) {
      if (k.indexOf(' ') > -1 && n.indexOf(k) > -1) n = n.split(k).join(SYN[k]);
    });
    return n.split(/[^a-z0-9]+/).map(function (w) {
      return SYN[w] || w;
    }).filter(function (w) { return w.length > 2 && !STOP[w]; });
  }

  /* I token arrivano al singolare (SYN), i titoli no: «Set Cilindri Bianchi» non
     contiene «cilindro» ne' «bianco». Dalle 5 lettere si confronta anche la radice
     senza la vocale finale; sotto no, «arc» prenderebbe troppo. */
  function has(hay, w) {
    if (hay.indexOf(w) > -1) return true;
    return w.length >= 5 && /[aeio]$/.test(w) && hay.indexOf(w.slice(0, -1)) > -1;
  }

  /* Punteggio: il titolo pesa piu' del tipo, il tipo piu' del tag. Un prodotto va
     proposto solo se davvero c'entra, altrimenti Max sembra uno che tira a indovinare. */
  function searchProducts(text, limit) {
    if (!CAT) return [];
    var tk = tokens(text);
    if (!tk.length) return [];
    // Il rivestimento ha «Arco»/«Vela» nel titolo ma e' solo la stampa da montare su
    // una struttura che si ha gia': a «quanto costa un arco» rispondere 28,90 € e' falso.
    // Sale solo se il cliente lo chiede (rivestimento, «solo la stampa», «ho gia' l'arco»).
    var wantsCover = tk.indexOf('rivestimento') > -1 || hasAny(normalize(text), POSTER_KWS);
    var scored = [];
    CAT.p.forEach(function (pr) {
      var title = normalize(pr.t);
      var type = normalize(pr.ty || '');
      var fam = normalize(pr.f || '');
      var tags = normalize((pr.tg || []).join(' '));
      var score = 0;
      tk.forEach(function (w) {
        if (has(title, w)) score += 10;
        else if (has(type, w)) score += 6;
        else if (has(fam, w)) score += 5;
        else if (has(tags, w)) score += 3;
        else if (pr.h.indexOf(w) > -1) score += 3;
      });
      if (!score) return;
      // Chi cerca senza dire «bianco» quasi sempre vuole vedere la versione stampata:
      // e' quella che mostra cosa sa fare SagoMax (ed e' quella che vende).
      if (tk.indexOf('bianco') === -1 && pr.m === 'stampato') score += 2;
      if (pr.ty === 'Rivestimento' && !wantsCover) score -= 6;
      if (!pr.a) score -= 8;
      scored.push({ p: pr, s: score });
    });
    scored.sort(function (a, b) { return b.s - a.s || a.p.pr - b.p.pr; });
    return scored.slice(0, limit || 3).map(function (x) { return x.p; });
  }

  /* «Fammi vedere i set» chiede la panoramica dei set, non i prodotti che hanno
     «Set» nel nome (Pronto Party, Set Archi Ondulati…). Si va alla panoramica quando,
     tolto «set», nessuna parola nomina un prodotto per titolo, tipo o famiglia:
     «set max» o «set archi ondulati» restano prodotti precisi; «set per battesimo»
     no, perche' l'evento sta solo nei tag. */
  function wantsSetsOverview(text) {
    var n = normalize(text);
    if (!/\bset\b|\bkit\b|pacchetto|tutto compreso/.test(n) && tokens(text).indexOf('set') === -1) return false;
    var rest = tokens(text).filter(function (w) { return w !== 'set'; });
    if (!rest.length || !CAT) return true;
    return !CAT.p.some(function (pr) {
      var where = normalize(pr.t) + ' ' + normalize(pr.ty || '') + ' ' + normalize(pr.f || '');
      return rest.some(function (w) { return has(where, w); });
    });
  }

  function findCollection(text) {
    if (!CAT || !CAT.c) return null;
    var n = normalize(text);
    var best = null;
    CAT.c.forEach(function (c) {
      var t = normalize(c.t).replace('allestimenti ', '');
      if (t.length > 3 && n.indexOf(t) > -1 && (!best || t.length > normalize(best.t).length)) best = c;
    });
    return best;
  }

  /* Le card: il cliente deve poter ARRIVARE al prodotto, non solo sentirne parlare. */
  function addCards(items) {
    if (!items || !items.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'sx-wa__cards';
    items.forEach(function (pr) {
      var a = document.createElement('a');
      a.className = 'sx-wa__card';
      a.href = pr.u;
      if (pr.i) {
        var im = document.createElement('span');
        im.className = 'sx-wa__card-img';
        im.style.backgroundImage = 'url("' + pr.i + '")';
        a.appendChild(im);
      }
      var bd = document.createElement('span');
      bd.className = 'sx-wa__card-body';
      var nm = document.createElement('span');
      nm.className = 'sx-wa__card-name';
      nm.textContent = pr.t;
      var pz = document.createElement('span');
      pz.className = 'sx-wa__card-price';
      pz.textContent = prezzoCorto(pr);
      bd.appendChild(nm); bd.appendChild(pz);
      a.appendChild(bd);
      var go = document.createElement('span');
      go.className = 'sx-wa__card-go';
      go.textContent = 'Apri';
      a.appendChild(go);
      wrap.appendChild(a);
    });
    body.insertBefore(wrap, quick);
    scrollDown();
  }

  function sizeLines(pr) {
    if (!pr.vr || pr.vr.length < 2) return '';
    return pr.vr.slice(0, 6).map(function (v) {
      return '• ' + v[0] + ' — ' + euro(v[1]);
    }).join('\n');
  }

  /* Risposta di prodotto: prezzo vero, misure vere, e sempre un passo dopo. */
  function answerProducts(text, list) {
    var n = normalize(text);
    var wantsPrice = /costa|prezzo|prezzi|costo|quanto vien|budget|spender/.test(n);
    var wantsSize = /misur|dimension|grande|altezz|larghezz|quanto e alto|cm\b/.test(n);
    var top = list[0];
    var msg;

    if (list.length === 1 || (top && list[1] && top.pr !== list[1].pr && wantsPrice)) {
      msg = top.mq
        ? top.t + ': ' + euro(top.pr) + ' al metro quadro, IVA inclusa. Il totale lo vedi subito nella sua pagina, scrivendo le tue misure.'
        : top.t + ': si parte da ' + euro(top.pr) + ', IVA inclusa.';
      if (wantsSize || wantsPrice) {
        var lines = sizeLines(top);
        if (lines) msg += '\nLe misure disponibili:\n' + lines;
      }
      if (top.m === 'stampato') msg += '\nLa grafica la prepariamo noi ed \u00e8 gi\u00e0 compresa nel prezzo.';
      else if (top.m === 'bianco') msg += '\nQuesta \u00e8 la versione bianca: la personalizzi aggiungendo il rivestimento stampato.';
      msg += '\nTe lo apro qui sotto 👇';
    } else {
      msg = 'Ecco cosa ho per te' + (wantsPrice ? ', con i prezzi' : '') + ':';
      list.forEach(function (pr) {
        msg += '\n• ' + pr.t + ' — ' + prezzoCorto(pr);
      });
      msg += '\nAprili pure qui sotto: dimmi quale ti convince e ti racconto tutto.';
    }
    botReply(msg, {
      after: function () {
        addCards(list);
        renderChips(followUpChips(top));
      }
    });
    return true;
  }

  /* Dopo una risposta di prodotto le scorciatoie diventano commerciali:
     il cliente non deve mai restare senza un passo successivo. */
  function followUpChips(pr) {
    var items = [];
    if (pr && pr.vr && pr.vr.length > 1) {
      items.push({ label: 'Che misura mi consigli?', onClick: function () { addMsg('Che misura mi consigli?', 'user'); botReply(A.misure, { after: resetChips }); } });
    }
    items.push({ label: 'Set completi', onClick: function () { addMsg('Fammi vedere i set completi', 'user'); setsAnswer(); } });
    items.push({ label: 'Tempi di consegna', onClick: function () { askTopic({ id: 'tempi', q: 'In quanto arriva?' }); } });
    items.push({ label: 'Come funziona', onClick: function () { askTopic({ id: 'ordine', q: 'Come funziona?' }); } });
    return items;
  }

  /* I set sono il prodotto piu' redditizio: Max li propone con il vantaggio in chiaro. */
  function setsAnswer() {
    loadCatalog().then(function () {
      var sets = CAT ? CAT.p.filter(function (x) { return x.m === 'set'; }).sort(function (a, b) { return b.pr - a.pr; }) : [];
      if (!sets.length) { botReply(A.prodotti); return; }
      var max = sets[0];
      var min = sets[sets.length - 1];
      botReply(
        'I set sono la scorciatoia intelligente: i pezzi sono gli stessi del catalogo, gia’ abbinati nelle misure giuste e con la stessa grafica su tutto — e costano meno che presi singolarmente.\n' +
        'Si parte dal ' + min.t + ' a ' + euro(min.pr) + ' e si arriva al ' + max.t + ' a ' + euro(max.pr) + ', che e’ il piu’ completo.\n' +
        'Guardali qui sotto: il ' + max.t + ' e’ quello che fa dire «wow» appena si entra.',
        { after: function () { addCards(sets.slice(0, 3)); resetChips(); } }
      );
    });
  }

  /* Consiglio per evento: collezione curata + il set, che e' la risposta piu' utile
     a «cosa mi serve per un battesimo?». */
  function eventAnswer(text) {
    var col = findCollection(text);
    if (!col) return false;
    var sets = CAT ? CAT.p.filter(function (x) { return x.m === 'set'; }).sort(function (a, b) { return b.pr - a.pr; }) : [];
    var msg = 'Per ' + col.t.replace(/^Allestimenti /i, '').toLowerCase() + ' ho una selezione gia’ pronta: ' + col.n + ' allestimenti pensati apposta.\n' +
      'Se vuoi andare sul sicuro senza scegliere pezzo per pezzo, i set fanno tutto da soli — stessa grafica su ogni elemento e un prezzo piu\u2019 basso dei pezzi singoli.';
    botReply(msg, {
      after: function () {
        var wrap = document.createElement('div');
        wrap.className = 'sx-wa__cards';
        var a = document.createElement('a');
        a.className = 'sx-wa__card sx-wa__card--coll';
        a.href = col.u;
        var bd = document.createElement('span');
        bd.className = 'sx-wa__card-body';
        var nm = document.createElement('span');
        nm.className = 'sx-wa__card-name';
        nm.textContent = col.t;
        var sub = document.createElement('span');
        sub.className = 'sx-wa__card-price';
        sub.textContent = col.n + ' prodotti';
        bd.appendChild(nm); bd.appendChild(sub);
        a.appendChild(bd);
        var go = document.createElement('span');
        go.className = 'sx-wa__card-go';
        go.textContent = 'Vedi';
        a.appendChild(go);
        wrap.appendChild(a);
        body.insertBefore(wrap, quick);
        if (sets.length) addCards([sets[0]]);
        renderChips(followUpChips(sets[0]));
      }
    });
    return true;
  }

  var PROGETTO_PREFILL = 'Ciao SagoMax! Vorrei richiedere un progetto personalizzato. Vi racconto il mio evento:';
  var PROGETTO_ANSWER = "Su misura e\u2019 il nostro standard, non un extra: ogni pezzo lo stampiamo con la tua grafica, e l\u2019elaborazione grafica e\u2019 sempre inclusa.\nRaccontami due cose e ti porto dritto al prodotto giusto: che evento e\u2019, e quanto spazio hai da riempire.\nSe vuoi il colpo d\u2019occhio senza pensarci troppo, i set completi sono gia\u2019 abbinati e costano meno dei pezzi singoli.";

  /* ================= Matching engine ================= */
  function normalize(s) {
    return (s || '').toString().toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '') // strip accents
      .replace(/[^a-z0-9\s]/g, ' ')                     // punctuation -> space
      .replace(/(.)\1{2,}/g, '$1$1')                    // ciaooo -> ciaoo
      .replace(/\s+/g, ' ').trim();
  }

  function hasAny(n, kws) {
    for (var i = 0; i < kws.length; i++) { if (n.indexOf(kws[i]) !== -1) return true; }
    return false;
  }

  function lev(a, b) {
    var m = a.length, n = b.length;
    if (!m) return n; if (!n) return m;
    var prev = [], cur = [], i, j;
    for (j = 0; j <= n; j++) prev[j] = j;
    for (i = 1; i <= m; i++) {
      cur[0] = i;
      for (j = 1; j <= n; j++) {
        var cost = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(cur[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
      }
      var tmp = prev; prev = cur; cur = tmp;
    }
    return prev[n];
  }

  function fuzzyIntent(n) {
    var tokens = n.split(' '), best = null, bestD = 99;
    for (var i = 0; i < tokens.length; i++) {
      var tok = tokens[i];
      if (tok.length < 4) continue;
      for (var w in FUZZY) {
        var thr = w.length >= 8 ? 2 : 1;
        var d = lev(tok, w);
        if (d <= thr && d < bestD) { bestD = d; best = FUZZY[w]; if (d === 0) return best; }
      }
    }
    return best;
  }

  function socialIntent(n) {
    var order = ['botq', 'greeting', 'thanks', 'bye', 'affirm'];
    for (var i = 0; i < order.length; i++) { if (hasAny(n, SOCIAL[order[i]].kws)) return order[i]; }
    return null;
  }

  // -> {type:'answer',id} | {type:'social',id} | {type:'human'} | {type:'reclamo'} | {type:'unknown'}
  function classify(text) {
    var n = normalize(text);
    if (!n) return { type: 'unknown' };
    if (EXACT[n]) return { type: 'social', id: EXACT[n] };
    // Identity questions ("sei una persona vera o un bot?") before the human route.
    if (hasAny(n, SOCIAL.botq.kws)) return { type: 'social', id: 'botq' };
    if (hasAny(n, ROUTES[0].kws)) return { type: 'human' };
    if (hasAny(n, ROUTES[1].kws)) return { type: 'reclamo' };
    for (var i = 2; i < ROUTES.length; i++) { if (hasAny(n, ROUTES[i].kws)) return { type: 'answer', id: ROUTES[i].id }; }
    var fz = fuzzyIntent(n);
    if (fz) return fz === '__human__' ? { type: 'human' } : { type: 'answer', id: fz };
    var soc = socialIntent(n);
    if (soc) return { type: 'social', id: soc };
    return { type: 'unknown' };
  }

  function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

  /* ================= WhatsApp link (hidden until needed) ================= */
  function waLink(text) {
    return 'https://wa.me/' + PHONE + '?text=' + encodeURIComponent(text || PREFILL);
  }
  // Reveal/hide the green WhatsApp CTA. Kept out of sight during normal answers;
  // shown only on a fallback or a human-operator request (always framed kindly).
  function setWA(show, text) {
    if (show) { cta.setAttribute('href', waLink(text || PREFILL)); root.classList.add('sx-wa--wa'); }
    else { root.classList.remove('sx-wa--wa'); }
  }
  function openWhatsApp(text) { window.open(waLink(text), '_blank', 'noopener'); }

  /* ================= Rendering ================= */
  function scrollDown() { body.scrollTop = body.scrollHeight; }

  function avatarEl() {
    var av = document.createElement('span');
    av.className = 'sx-wa__msg-av';
    av.style.backgroundImage = 'url("' + AVATAR + '")';
    return av;
  }

  function addMsg(text, who) {
    var wrap = document.createElement('div');
    wrap.className = 'sx-wa__msg sx-wa__msg--' + who;
    if (who === 'bot' && AVATAR) wrap.appendChild(avatarEl());
    var bubble = document.createElement('div');
    bubble.className = 'sx-wa__bubble';
    bubble.textContent = text;
    wrap.appendChild(bubble);
    body.insertBefore(wrap, quick);
    scrollDown();
    return wrap;
  }

  function showTyping() {
    var wrap = document.createElement('div');
    wrap.className = 'sx-wa__msg sx-wa__msg--bot';
    if (AVATAR) wrap.appendChild(avatarEl());
    var bubble = document.createElement('div');
    bubble.className = 'sx-wa__bubble';
    bubble.innerHTML = '<span class="sx-wa__typing"><span></span><span></span><span></span></span>';
    wrap.appendChild(bubble);
    body.insertBefore(wrap, quick);
    scrollDown();
    return wrap;
  }

  function renderChips(items) {
    quick.innerHTML = '';
    items.forEach(function (it) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sx-wa__chip';
      btn.textContent = it.label;
      btn.addEventListener('click', it.onClick);
      quick.appendChild(btn);
    });
    scrollDown();
  }

  function topicChips() {
    return TOPICS.map(function (t) {
      return {
        label: t.chip,
        onClick: function () { t.run ? t.run() : askTopic(t); }
      };
    });
  }
  function resetChips() { renderChips(topicChips()); }

  // Typing time scales with the answer length so Max feels like it's "writing".
  function typingDelay(text) { return Math.max(550, Math.min(1500, 350 + (text ? text.length : 0) * 9)); }

  function botReply(text, opts) {
    opts = opts || {};
    var typing = showTyping();
    quick.innerHTML = '';
    window.setTimeout(function () {
      typing.remove();
      addMsg(text, 'bot');
      if (opts.after) opts.after();
      else resetChips();
      // If a chip that had keyboard focus was just removed, focus fell to <body>;
      // restore it to the first new chip. Never steal focus from the text input.
      var ae = document.activeElement;
      if (isOpen && (!ae || ae === document.body)) {
        var firstChip = quick.querySelector('.sx-wa__chip');
        if (firstChip) firstChip.focus();
      }
    }, opts.delay || typingDelay(text));
  }

  /* ================= Conversation flows ================= */
  function askTopic(topic) {
    capito();
    addMsg(topic.q, 'user');
    setWA(false);
    botReply(A[topic.id]);
  }

  function respond(text) {
    var c = classify(text);
    if (c.type === 'social') { capito(); setWA(false); botReply(pick(SOCIAL[c.id].replies)); return; }
    if (c.type === 'reclamo') { capito(); reclamoHandoff(text); return; }
    if (c.type === 'human') { humanHandoff(text); return; }

    // Il catalogo entra PRIMA delle risposte generiche, ma non le travolge:
    // «quanto costa un arco» deve dare il prezzo dell'arco, mentre «che materiali usate
    // per gli archi» deve dare i materiali — e mostrare gli archi accanto alla risposta.
    setWA(false);
    loadCatalog().then(function () {
      var n = normalize(text);
      var wantsPrice = /costa|prezzo|prezzi|costo|quanto vien|budget|spender/.test(n);
      var wantsSize = /misur|dimension|grande|altezz|larghezz|cm\b/.test(n);
      var hits = searchProducts(text, 3);

      if (wantsSetsOverview(text)) {
        capito();
        setsAnswer();
        return;
      }
      // «cosa mi consigli per un battesimo» non e' una domanda generica sugli eventi:
      // e' una richiesta di consiglio. Se riconosciamo l'occasione, la collezione curata
      // + il set valgono cento volte di piu' di un elenco di occasioni.
      if ((c.id === 'eventi' || /consigli|mi consigli|cosa mi serve|cosa serve|idee per/.test(n)) && eventAnswer(text)) { capito(); return; }

      if (c.type === 'answer' && !wantsPrice && !wantsSize) {
        capito();
        botReply(A[c.id], {
          after: function () {
            if (hits.length) { addCards(hits); renderChips(followUpChips(hits[0])); }
            else resetChips();
          }
        });
        return;
      }
      if (hits.length) { capito(); answerProducts(text, hits); return; }
      if (eventAnswer(text)) { capito(); return; }
      if (c.type === 'answer') { capito(); botReply(A[c.id]); return; }
      fallback(text);
    });
  }

  // Chi chiede una persona la ottiene subito. Prima Max provava a trattenerlo un giro
  // («prova me, conosco il catalogo»): e' esattamente il comportamento che fa detestare
  // i chatbot, e su una richiesta di aiuto costa piu' di quanto faccia risparmiare.
  // Max resta a disposizione nella stessa frase, ma la porta e' gia' aperta.
  function humanHandoff(text, dopoUnBuco) {
    mancati = 0;
    setWA(true, text);
    botReply(
      dopoUnBuco
        ? 'Qui non ci arrivo, e non voglio farti perdere altro tempo: ti passo una persona del team.\n' +
          'Tocca il pulsante verde qui sotto — il messaggio è già pronto, devi solo inviarlo.'
        : 'Certo. Tocca il pulsante verde qui sotto e continui su WhatsApp con una persona del team: il messaggio è già pronto.\n' +
          'Se intanto vuoi provare con me, chiedi pure: prezzi, misure e tempi li ho tutti qui.',
      { after: resetChips }
    );
  }

  // Un problema su un ordine e' l'unico caso in cui passare una persona e' la cosa
  // giusta al primo colpo: qui non si vende, si ripara.
  function reclamoHandoff(text) {
    setWA(true, text);
    botReply('Mi dispiace, e voglio sistemarla. Qui sotto ti apro WhatsApp: ti risponde una persona del team con il tuo ordine davanti.');
  }

  // Quante domande di fila Max non ha capito. Si azzera appena ne capisce una
  // (vedi le chiamate a capito()): conta la serie, non il totale della chat.
  var mancati = 0;
  function capito() { mancati = 0; }

  // Al primo buco Max riprova, perche' spesso basta riformulare e il sito sa
  // rispondere meglio di una persona alle 23. Al SECONDO buco di fila si arrende e
  // passa la mano: due domande a vuoto sono gia' il momento in cui si chiude la chat.
  function fallback(text) {
    mancati++;
    if (mancati >= 2) { humanHandoff(text, true); return; }
    setWA(false);
    var fam = [];
    if (CAT) {
      var seen = {};
      CAT.p.forEach(function (pr) {
        var f = pr.f || pr.ty;
        if (f && !seen[f]) { seen[f] = 1; fam.push(f); }
      });
    }
    var msg = 'Questa me la sono persa. Riproviamo: scrivimi il pezzo che ti interessa oppure l\u2019occasione.';
    if (fam.length) msg += '\nHo ' + fam.slice(0, 6).join(', ').toLowerCase() + ' e altro ancora \u2014 e per ognuno so misure e prezzo.';
    botReply(msg, {
      after: function () {
        renderChips([
          { label: 'Set completi', onClick: function () { addMsg('Fammi vedere i set', 'user'); setsAnswer(); } },
          { label: 'Archi e vele', onClick: function () { addMsg('Archi e vele', 'user'); respond('arco vela'); } },
          { label: 'Sagome', onClick: function () { addMsg('Sagome', 'user'); respond('sagoma'); } },
          { label: 'Fondali', onClick: function () { addMsg('Fondali', 'user'); respond('fondale'); } },
          { label: 'Come funziona', onClick: function () { askTopic({ id: 'ordine', q: 'Come funziona?' }); } },
          { label: 'Parla con una persona', onClick: function () {
              addMsg('Vorrei parlare con una persona', 'user');
              humanHandoff('Ciao SagoMax, vorrei parlare con una persona del team.');
            } }
        ]);
      }
    });
  }

  // Guided "custom project" flow (hero CTA). Automated reply + WhatsApp offered.
  var progettoStarted = false;
  function startProgetto() {
    setWA(true, PROGETTO_PREFILL);
    if (progettoStarted) { scrollDown(); return; }
    progettoStarted = true;
    addMsg('Vorrei richiedere un progetto personalizzato ✨', 'user');
    botReply(PROGETTO_ANSWER);
  }

  function handleFreeText(text) {
    addMsg(text, 'user');
    if (BACKEND) { relayViaBackend(text); return; }
    respond(text);
  }

  /* ================= Optional middleware relay ================= */
  var sessionId = null;
  function getSessionId() {
    if (sessionId) return sessionId;
    try { sessionId = sessionStorage.getItem('sxwa_sid'); } catch (e) {}
    if (!sessionId) {
      sessionId = 'sx-' + Math.random().toString(36).slice(2) + '-' + (window.performance ? Math.round(performance.now()) : 0);
      try { sessionStorage.setItem('sxwa_sid', sessionId); } catch (e) {}
    }
    return sessionId;
  }

  function relayViaBackend(text) {
    var typing = showTyping();
    quick.innerHTML = '';
    fetch(BACKEND + '/site-message', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sessionId: getSessionId(), text: text, url: location.href })
    }).then(function (r) {
      if (!r.ok) throw new Error('relay failed');
      return r.json();
    }).then(function (data) {
      typing.remove();
      addMsg((data && data.reply) || 'Ho inoltrato il tuo messaggio: ti rispondiamo al più presto 💕', 'bot');
      resetChips();
    }).catch(function () {
      typing.remove();
      addMsg("Non riesco a raggiungerti in questo momento 😞 Continua su WhatsApp e ti rispondiamo subito.", 'bot');
      setWA(true, text);
      resetChips();
    });
  }

  /* ================= Panel open / close ================= */
  var isOpen = false;
  var built = false;

  function build() {
    if (built) return;
    resetChips();
    built = true;
  }

  function openPanel() {
    build();
    panel.hidden = false;
    root.classList.add('is-open');
    fab.setAttribute('aria-expanded', 'true');
    isOpen = true;
    try { sessionStorage.setItem('sxwa_opened', '1'); } catch (e) {}
    root.classList.add('is-seen');
    window.setTimeout(function () {
      var firstChip = quick.querySelector('.sx-wa__chip');
      if (firstChip) firstChip.focus();
    }, 60);
  }

  function closePanel() {
    panel.hidden = true;
    root.classList.remove('is-open');
    fab.setAttribute('aria-expanded', 'false');
    isOpen = false;
    fab.focus();
  }

  function toggle() { isOpen ? closePanel() : openPanel(); }

  function openProgetto() {
    if (!isOpen) openPanel();
    startProgetto();
  }

  fab.addEventListener('click', toggle);
  if (closeBtn) closeBtn.addEventListener('click', closePanel);

  // Public API + declarative hook. Any element with data-sx-wa-open opens the chat;
  // data-sx-wa-open="progetto" launches the guided custom-project flow. Lets the
  // hero's "Richiedi un progetto su misura" CTA open Max instead of jumping to wa.me,
  // while keeping its href as a graceful no-JS fallback.
  window.SagoMaxWA = {
    open: function (intent) { intent === 'progetto' ? openProgetto() : openPanel(); },
    close: closePanel,
    progetto: openProgetto,
    send: function (text) { if (!isOpen) openPanel(); handleFreeText(text); }
  };

  document.addEventListener('click', function (e) {
    var trigger = e.target && e.target.closest ? e.target.closest('[data-sx-wa-open]') : null;
    if (!trigger) return;
    e.preventDefault();
    window.SagoMaxWA.open(trigger.getAttribute('data-sx-wa-open'));
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = (input.value || '').trim();
    if (!text) return;
    input.value = '';
    handleFreeText(text);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closePanel();
  });

  // Click outside closes the panel. composedPath() (captured at dispatch) rather
  // than live DOM containment: a chip re-renders and detaches ITSELF during its own
  // click handler, so root.contains(e.target) would wrongly read the tap as outside.
  document.addEventListener('click', function (e) {
    if (!isOpen) return;
    if (e.target && e.target.closest && e.target.closest('[data-sx-wa-open]')) return;
    var path = typeof e.composedPath === 'function' ? e.composedPath() : null;
    if (path && path.indexOf(root) !== -1) return;
    if (root.contains(e.target)) return;
    closePanel();
  });

  // Quiet the pulse if the visitor has already opened it this session.
  try { if (sessionStorage.getItem('sxwa_opened')) root.classList.add('is-seen'); } catch (e) {}
})();
